import Vue from 'vue'
import Vuex from 'vuex'
import {getRongCloudToken} from "../utils/interface";
import * as RongIMLib from "@rongcloud/imlib-next";
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        menuActiveId: '0',  //当前路由选中id
        userMessages: '',  //用户信息储存

        chatRecord:{},
        isChatting: false,
        //ceshi
        allPark: true,
        isLogin: false,
        menuListShow: false,
    },
    mutations: {
        updateMenuActiveId (state, menuActiveId) {
            state.menuActiveId = menuActiveId
        },
        // 登录后
        isLoginVuex(state, val){
          state.isLogin = val
        },
        vuexAllPark(state, val){
          state.allPark = val
        },
        //ceshi
        vuexAllPark(state, val){
            state.allPark = val
        },
         // 登录后
        isLoginVuex(state, val){
            state.isLogin = val
        },
       userMessagesVuex (state, userMessages){
           state.userMessages = userMessages;
           getRongCloudToken({
               userId: userMessages.uuid,
               userName: userMessages.name,
               userPhoto: userMessages.headUrl
           }).then((res) => {
               state.rongCloudToken = res.data;
               //连接融云
               let token = res.data;
               RongIMLib.connect(token).then(res => {
                   // if (res.code === 0) {
                   //     console.log('当前用户：---'+res.data.userId)
                   // }
                   if (res.code === 0) {
                     console.log('当前用户：---'+res.data.userId)
                     //获取会话未读数
                     const includeMuted = false
                     const conversationTypes = [RongIMLib.ConversationType.PRIVATE]
                     RongIMLib.getTotalUnreadCount(includeMuted, conversationTypes).then(res => {
                       if (res.code === 0) {
                         this.state.unReadMsgCount = res.data
                       } else {
                         console.log(res.code, res.msg)
                       }
                     }).catch(error => {
                       console.log(error)
                     })
                   }
               });
           })
       },
       // 储存用户信息
       isStorageUsermessage(state, val){
         state.userMessages = val;
         getRongCloudToken({
           userId: val.uuid,
           userName: val.name,
           userPhoto: val.headUrl
         }).then((res) => {
           state.rongCloudToken = res.data;
           //连接融云
           let token = res.data;
           RongIMLib.connect(token).then(res => {
             if (res.code === 0) {
               console.log('当前用户：---'+res.data.userId)
               //获取会话未读数
               const includeMuted = false
               const conversationTypes = [RongIMLib.ConversationType.PRIVATE]
               RongIMLib.getTotalUnreadCount(includeMuted, conversationTypes).then(res => {
                 if (res.code === 0) {
                   this.state.unReadMsgCount = res.data
                 } else {
                   console.log(res.code, res.msg)
                 }
               }).catch(error => {
                 console.log(error)
               })
             }
           });
         })
       },
        isChattingVuex(state, val){
            state.isChatting = val
        },

        clearChatRecords(state,val) {
            state.chatRecord[val] = [];
        },
        menuListShowVuex(state,val){
            state.menuListShow = val
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js